import script from "./UserDndList.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDndList.vue?vue&type=script&lang=ts&setup=true"

import "./UserDndList.vue?vue&type=style&index=0&id=b24d9782&scoped=true&lang=scss"
script.__scopeId = "data-v-b24d9782"

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QItemSection,QItemLabel,QItem});
